import React, { useEffect ,useState} from "react";
import { useParams } from 'react-router-dom';
import {storage} from "../../firebase.config";
import {ref,listAll,deleteObject} from "firebase/storage"
import { Link } from "react-router-dom";
import FullPageLoader from '../../utils/loader';
import {useSelector} from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css



const FolderList = (props) => {
    const [folderList, setFolderList] = useState([]);
    const [isLoading,setLoading] = useState(false);
    const [folderDeleting,setFolderDeleting] = useState([]);

    const { username } = useParams();
    const sortBy  = useSelector((state) => state.changeOrder)

    const listAllFolders = async () => {
        try {
            setLoading(true)
            const userRef = ref(storage, username);
            const items = await listAll(userRef);
            const folders = items.prefixes.map((prefix) => prefix.fullPath.replace(`${username}/`,""))//.sort(naturalSort);
            setLoading(false)
            setFolderList(folders);
        } catch (error) {
            setLoading(false)
            setFolderList([]);
            console.error('Error listing folders:', error.message);
        }
      };
  
    useEffect(() => {
        listAllFolders();
    },[username]);

    async function deleteFolder(date) {
        setFolderDeleting((prev)=>[...prev,date])
        const dateRef = ref(storage, `/${username}/${date}`);
        // Get all lot folder within the date-folder
        const lotResult = await listAll(dateRef);
        for (const lotFolder of lotResult.prefixes) {
          const lotResult = await listAll(lotFolder);
            for (const subItem of lotResult.items) {
                await deleteObject(subItem);
            }
        }
        setFolderDeleting((prev)=>prev.filter(item => item !== date))
      }

    const deleteAlert  = (e,date) => {
        e.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                <div className='custom-ui'>
                    <h1>Delete Folder</h1>
                    <p>Are you sure you want to delete this folder?</p>
                    <button onClick={onClose}>No</button>
                    <button onClick={() => { deleteFolder(date); onClose(); }} >
                        Yes, Delete it!
                    </button>
                </div>
                );
            }
            });
      };

    return (
        <div className="container-fluid height-74">
             { isLoading  &&    <FullPageLoader/> }
            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800 text-capitalize">{username}</h1>
            </div>
            <hr/> */}

            <div className="row">
                {
                    folderList.length>0 &&
                        // folderList.sort(sortBy === 'ascending' ? (a, b) => new Date(a) - new Date(b) : (a, b) => new Date(b) - new Date(a)).map((date, index) => {
                            folderList.map((date, index) => {
                                return (
                                    <Link to={`/${username}/${date}`} className="col-xl-2 col-md-6 mb-4 text-decoration-none" key={index}>
                                        <div className="card border-left-primary shadow h-100 py-2">
                                            <div className="card-body">
                                                <img src={require("../../img/folder1.png")}  alt="folder-icon" />
                                                <div className="text-xs font-weight-bold text-primary text-capitalize mb-1"> {date}</div>
                                                {/* <div className="h5 mb-0 font-weight-bold text-gray-800">{item}</div> */}
                                            </div>
                                            <div className="delete-container" onClick={(e)=>!folderDeleting.includes(date) ? deleteAlert(e,date) :{}} >
                                                {
                                                    !folderDeleting.includes(date) ? 
                                                        <div className="delete-div">
                                                            <img src={require("../../img/trash.png")}  alt="trash-icon" />
                                                        </div> 
                                                    :  <div className="loader"></div>
                                                }
                                            </div>
                                        </div>
                                       
                                    </Link>
                                )
                            })
                }
               
            </div>
            {
                folderList.length === 0 && !isLoading &&
                    <div  className="no-data-center" >
                            <div className="no-data-center-font"> No Data </div>
                    </div>
            }
        </div>
    );
}

export default FolderList;